import { useEffect } from 'react';
import { Button } from '../button';
import { Row, Col } from '../grid';
import ScrollToError from '../scrollToError';
import { StyledFormActions, StyledFormActionsWrapper } from './style';

let $ = window['$'];

const checkScroll = () => {
  let el = $('#form-action-wrapper')[0];
  let rect = el.getBoundingClientRect();
  let isVisible = (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );

  if(isVisible){
    $('#form-actions').removeClass('sticky')
  }
  else {
    $('#form-actions').addClass('sticky')
  }
}

export const FormActions = (props) => {
  useEffect(() => {
    window.setTimeout(() => checkScroll(), 300);

    $(window).on('scroll', () => {
      checkScroll();
    });
  }, []);

  let back;
  if(props.backUrl){
    back = <Button
      href={props.backUrl}
      buttonStyle="default"
      icon="angle-left"
      description={props.backDescription}
    >
      Voltar
    </Button>;
  }

  let content;
  if(props.columns === 'one') {
    content = (
      <>
        {props.children}
        {back}
      </>
    );
  }
  else {
    content = (
      <Row>
        <Col>
          {back}
        </Col>

        <Col className="submit-wrapper">
          {props.children}
        </Col>
      </Row>
    );
  }

  return (
    <StyledFormActionsWrapper id="form-action-wrapper">
      <StyledFormActions {...props} id="form-actions">
        <div id="form-action-container">
          {content}
        </div>
      </StyledFormActions>

      <ScrollToError />
    </StyledFormActionsWrapper>
  )
}
